<template>
  <div class="animated fadeIn">
    <b-card no-body class="card-default min-vh-85">
      <div slot="header">
        <span>Recursos</span>
      </div>

      <b-col>
        <b-container fluid v-if="flagSearch" class="animated fadeIn pt-2 pb-2">
          <loader v-if="$root.isLoading || isLoading"></loader>
          <NavContent v-on:styleList="onSelectStyleList($event)">
            <template v-slot:tituloCabecera>Mis recursos</template>
          </NavContent>
          <filtro-recursos
            :show-filter="showFilter"
            v-on:filter="targetFilter"
            v-on:reset="resetFiltro"
          />
          <template v-if="listRecursos.length > 0">
            <slot v-if="typeViewList == 'block'">
              <b-card-group columns id="block-view-container" class="pb-5">
                <BlockContent
                  v-for="r in listRecursos"
                  :key="r._id"
                  :record="r"
                  :buttons="buttonsBlock"
                  v-on:btnClicked="onClickButton($event)"
                  class="cards"
                  @dataCheckedRecursos="checkedRecursos($event)"
                >
                  <img
                    v-if="r.type == 'IMAGEN'"
                    :src="$root.setUrlFile(r.file)"
                    class="video-preview"
                    :alt="r.file"
                  />
                  <audio v-else-if="r.type == 'AUDIO'" class="audio-preview" controls autobuffer>
                    <source :src="$root.setUrlFile(r.file)" />
                  </audio>
                  <video v-else class="video-preview" controls>
                    <source :src="$root.setUrlFile(r.file)" />
                  </video>
                </BlockContent>
              </b-card-group>
            </slot>
            <slot v-else-if="typeViewList == 'list'">
              <TableContent
                :buttons="buttonsBlock"
                v-on:btnClicked="onClickButton($event)"
                :table-data="listRecursos"
                :fields="tableFields"
                :per-page="dataPagination.limit"
                :show-pagination="false"
                class="cards-list"
                @dataCheckedRecursos="checkedRecursos($event)"
              />
            </slot>
            <b-pagination
              class="paginador-cme"
              v-on:change="getListRecursos($event)"
              :total-rows="dataPagination.totalDocs"
              :per-page="dataPagination.limit"
              v-model="dataPagination.page"
              prev-text="Anterior"
              next-text="Siguiente"
              hide-goto-end-buttons
            />
          </template>
          <template v-if="listRecursos.length == 0">
            <h3 style="text-align: center;">No Existen Recursos con el Filtro de Búsqueda</h3>
          </template>
        </b-container>

        <b-container v-else class="pt-2 pb-3">
          <b-col class="text-center mt-3">
            <h3>¿Buscas Algún Tema en Especial?</h3>
            <b-input-group>
              <b-form-input
                v-model.trim="wordSearch"
                type="text"
                v-on:keyup=" ($event) => { $event.key == 'Enter' ? getListRecursos(1): false }"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="getListRecursos(1)" variant="primary">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-button class="mt-2" variant="link" @click="getListRecursos(1)">
              <p style="font-size: 1rem;">Mostrar Todo el Contenido</p>
            </b-button>
          </b-col>
        </b-container>
      </b-col>
    </b-card>
    <!--<slot v-if="$route.params.type == 'l'">
         <b-button @click="typeAction = 'save'" variant="primary" class="btn-fixed font-1xl" v-b-modal.modal-manage-record>
            <font-awesome-icon icon="plus" /> Nuevo Recurso
        </b-button>
    </slot>-->
    <slot v-if="$route.params.type == 'l'">
      <b-button variant="primary" class="btn-fixed font-1xl" v-b-modal.modal-upload-files>
        <font-awesome-icon class="icon-fx-btn" icon="plus" />Nuevo(s) Recurso(s)
      </b-button>
    </slot>
    <slot v-if="$route.params.type == 'l'">
      <b-button
        :variant="checkSelectedRecursos"
        @click="editarRecursos"
        class="btn-fixed-two font-1xl"
      >
        <font-awesome-icon class="icon-fx-btn" icon="edit" />Editar Recurso(s) seleccionado(s)
      </b-button>
    </slot>
    <!--- #################### MODALES ############## -->
    <!--para vista-->
    <b-modal id="modal-show-record" :title="recordForManage.type || ''" ref="modal-show-record">
      <b-row>
        <b-col>
          <img
            v-if="recordForManage.type == 'IMAGEN'"
            class="img-preview"
            :src="$root.setUrlFile(recordForManage.file)"
          />
          <audio
            v-else-if="recordForManage.type == 'AUDIO'"
            class="audio-preview"
            controls
            autobuffer
          >
            <source :src="$root.setUrlFile(recordForManage.file)" />
          </audio>
          <video v-else class="video-preview" controls>
            <source :src="$root.setUrlFile(recordForManage.file)" />
          </video>
          <p
            class="text-center mt-2"
            v-if="recordForManage.fechaUltimaActualizacion"
          >Última actualización: {{ recordForManage.fechaUltimaActualizacion | moment("D, MMMM YYYY") }}</p>
          <p>Etiquetas Registradas</p>
        </b-col>
      </b-row>
      <b-row class="justify-content-start">
        <b-col class="mb-2" v-for="(tag, index) in recordForManage.tags" :key="index">
          <b-col class="tag-recurso">
            <p>{{ tag }}</p>
          </b-col>
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <b-button @click="close">Cerrar</b-button>
      </div>
    </b-modal>

    <modal-upload-files @onSuccessFiles="resetFiltro"></modal-upload-files>

    <modal-editar-multi-recursos :dataSelected="selected" @onSuccessFiles="resetSelected"></modal-editar-multi-recursos>
  </div>
</template>
<script>
import NavContent from "@/components/NavContent";
import BlockContent from "@/components/BlockContent";
import TableContent from "@/components/TableContent";
import FiltroRecursos from "@/components/FiltroRecursos";
import RecursoService from "@/services/recurso.service";
import Loader from "@/components/Loader";
import ModalUploadFiles from "@/components/ModalUploadFiles";
import ModalEditarMultiRecursos from "@/components/ModalEditarMultiRecursos";
import { exists } from "fs";
export default {
  name: "Recursos",
  data() {
    return {
      recordForManage: {},
      newData: {
        file: null,
        categorias: [],
        tags: [],
        author: null,
        visibilidad: "PUBLICO"
      },
      newTag: "",
      listRecursos: [],
      modelFile: null,
      dataPagination: {
        page: 1,
        limit: 5,
        totalDocs: 0
      },
      user: this.$store.getters["auth/infoUser"],
      paramsList: {
        paginate: true,
        filtro: {
          type: null
        }
      },
      typeAction: "save",
      typeViewList: "block",
      tableFields: [
        {
          key: "file",
          label: "Recurso",
          tdClass: "nameWidth",
          sortable: false
        },
        {
          key: "type",
          label: "Tipo",
          sortable: true,
          tdClass: "typeWidth",
          class: "text-center"
        },
        {
          key: "tags",
          label: "Tags",
          tdClass: "tagWidth",
          class: "text-center"
        },
        {
          key: "fechaUltimaActualizacion",
          label: "Última actualización",
          sortable: true,
          tdClass: "dateWidth",
          class: "text-center"
        },
        {
          key: "actions",
          label: "Acciones",
          class: "text-center"
        }
      ],
      filePreview: null,
      fileToUpload: new FormData(),
      typeFile: null,
      flagSearch: false,
      showAll: false,
      showFilter: false,
      wordSearch: "",
      isLoading: false,
      selected: []
    };
  },
  components: {
    NavContent,
    BlockContent,
    TableContent,
    Loader,
    FiltroRecursos,
    ModalUploadFiles,
    ModalEditarMultiRecursos
  },
  created() {
    this.newData.author = this.user._id;
  },
  computed: {
    totalPages: function() {
      return this.getRowCount();
    },
    checkSelectedRecursos: function() {
      if (this.selected.length > 0) {
        return "primary";
      }
      return "light";
    }
  },
  watch: {
    $route(to, from) {
      this.getListRecursos(1);
    }
  },
  methods: {
    checkedRecursos(e) {
      if (e.checked) {
        // armamos el tag con text y tiClasses
        e.recurso.tempTags = [];
        e.recurso.isChecked = true;
        e.recurso.tags.forEach(t => {
          var tagData = { text: t, tiClasses: ["ti-valid"] };
          e.recurso.tempTags.push(tagData);
        });
        this.selected.push(e.recurso);
      } else {
        // buscamos de los recursos seleccionados el id para eliminarlo
        this.selected.forEach((el, i) => {
          if (el._id == e.recurso._id) {
            el.isChecked = false;
            this.selected.splice(i, 1);
          }
        });
      }

      //this.$store.dispatch('recursos/updateSelection',this.selected);
    },
    editarRecursos() {
      if (this.selected.length == 0) {
        this.$root.triggerWarnMgs(
          "Selecciona al menos un elemento para editar",
          ""
        );
      } else {
        this.$bvModal.show("modal-editar-multi-recursos");
      }
    },
    onSelectStyleList(e) {
      if (e == "filter") this.showFilter = !this.showFilter;
      else this.typeViewList = e;
      // al alternar entre vistas se debe verificar si de la lista de recursos existen seleccionados para ponerlos checked
      this.listRecursos.forEach(doc => {
        for (var i = 0; i < this.selected.length; i++) {
          if (doc._id == this.selected[i]._id) {
            doc.isChecked = true;
            break;
          }
        }
      });
    },
    resetFiltro() {
      this.paramsList.filtro = { type: null };
      this.wordSearch = "";
      this.getListRecursos(1);
    },
    resetSelected() {
      this.listRecursos.forEach(r => {
        for (var i = 0; i < this.selected.length; i++) {
          if (r._id == this.selected[i]._id) {
            r.isChecked = false;
            break;
          }
        }
      });
      this.selected = [];
      //this.resetFiltro();
    },
    validateParams(type) {
      return new Promise(response => {
        if (type == "l") {
          this.paramsList.filtro["$or"] = [
            { author: this.user._id },
            { compartido: { $in: [this.user._id] } }
          ];
          this.paramsList.filtro["$and"] = [
            { $or: [{ isDelete: null }, { isDelete: false }] }
          ];
          this.buttonsBlock = [
            {
              icon: "heart-broken",
              popover: "Desvincular",
              id: "btn_unshare"
            },
            {
              icon: "eye",
              popover: "Ver",
              id: "btn-show"
            },
            {
              icon: "trash",
              popover: "Eliminar",
              id: "btn-remove"
            }
          ];
        } else if (type == "o") {
          delete this.paramsList.filtro["$or"];
          this.paramsList.filtro["$and"] = [
            { author: { $ne: this.user._id } },
            { visibilidad: "PUBLICO" },
            { $or: [{ isDelete: null }, { isDelete: false }] }
          ];
          this.buttonsBlock = [
            {
              icon: "heart",
              popover: "Vincular",
              id: "btn-share"
            },
            {
              icon: "eye",
              popover: "Ver",
              id: "btn-show"
            }
          ];
        }
        response(true);
      });
    },
    getRowCount: function() {
      return this.arrayBlockElements.length;
    },
    targetFilter(e) {
      if (e.wordSearch) this.wordSearch = e.wordSearch;
      if (e.type) this.paramsList.filtro.type = e.type;
      this.getListRecursos(1);
    },
    getListRecursos(page) {
      this.isLoading = true;
      this.listRecursos = [];
      this.validateParams(this.$route.params.type)
        .then(_ => {
          if (this.wordSearch)
            this.paramsList.filtro["tags"] = {
              $regex: `.*${this.wordSearch}.*`,
              $options: "i"
            };
          var dataList = RecursoService.list(page, this.paramsList);
          this.isLoading = false;
          return dataList;
        })
        .then(response => {
          console.log(response);
          this.flagSearch = true;
          this.arrayBlockElements = new Array();
          this.dataPagination = JSON.parse(JSON.stringify(response));
          delete this.dataPagination.docs;
          // por cada recurso de la lista se verifica si existe en los seleccionados, si es así se mantiene con isChecked = true
          response.docs.forEach(doc => {
            for (var i = 0; i < this.selected.length; i++) {
              if (doc._id == this.selected[i]._id) {
                doc.isChecked = true;
                break;
              }
            }
          });
          this.listRecursos = response.docs;
          this.isLoading = false;
        })
        .catch(err => {
          console.error(err);
          this.isLoading = false;
        });
    },
    onClickButton(data) {
      if (data && data.id) {
        switch (data.id) {
          case "btn_unshare":
            if (data.record.author._id != this.user._id) {
              RecursoService.share({
                idResource: data.record._id,
                idUser: this.user._id
              }).then(res => {
                this.$root.triggetSuccessMgs(
                  "Excelente",
                  "El recurso se a desvinculado con exito"
                );
                setTimeout(() => {
                  this.getListRecursos(1);
                }, 100);
              });
            }
            break;
          case "btn-share":
            RecursoService.share({
              idResource: data.record._id,
              idUser: this.user._id
            }).then(res => {
              this.$root.triggetSuccessMgs(
                "Excelente",
                "El recurso se vinculo con exito"
              );
              setTimeout(() => {
                this.getListRecursos(1);
              }, 100);
            });
            break;
          case "btn-show":
            this.recordForManage = data.record;
            this.$refs["modal-show-record"].show();
            break;
          case "btn-remove":
            this.$swal({
              title: "¿Estás seguro de eliminar el recurso?",
              text: "Ya no podrás revertir esta acción",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "¡Sí, borrar!",
              cancelButtonText: "¡No, regresar!",
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then(result => {
              if (result.value) {
                data.record.isDelete = true;
                RecursoService.edit({
                  query: { _id: data.record._id },
                  data: data.record
                }).then(res => {
                  if (res) {
                    this.$root.triggetSuccessMgs(
                      "Recurso eliminado con éxito",
                      ""
                    );
                    this.getListRecursos(1);
                  }
                });
              } else {
              }
            });
          /*case "btn-edit":
            this.newData = data.record;
            this.typeAction = "edit";
            this.modelFile = "edit";
            this.filePreview = this.$root.setUrlFile(this.newData.file);
            this.$refs["modal-manage-record"].show();*/
        }
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      )
        return !this.errors.has(ref);
      return null;
    },
    close() {
      this.$bvModal.hide("modal-show-record");
    }
  }
};
</script>
<style lang="scss" scoped>
.video-preview,
.img-preview {
  display: block;
  margin: auto;
  max-width: 100%;
  border: solid 0.5rem #8f9ba6;
  border-radius: 0.2rem;
}

.audio-preview {
  display: block;
  margin: auto;
}

.tag-recurso {
  background: #58adc7;
  padding: 0.5rem 0rem 0.5rem 0rem;
  text-align: center;
  display: flex;
  justify-content: center;
  border: solid 0.2rem #4c94aa;
  border-radius: 0.2rem;

  p {
    margin: 0 1rem 0 1rem;
    color: #ffffff;
    font-weight: bold;
  }

  svg {
    margin-right: 0.5rem;
    cursor: pointer;
  }
}
.icon-fx-btn {
  margin-right: 5px;
}
</style>